import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Timetable from "@/pages/Timetable";
import Session from "@/pages/Session";
import Sessions from "@/pages/Sessions";
import Classes from "@/pages/Classes";
import ClassDetail from "@/pages/ClassDetail";
import Sections from "@/pages/Sections";
import SectionDetail from "@/pages/SectionDetail";
import Students from "@/pages/Students";
import StudentDetail from "@/pages/StudentDetail";
import TimetableAdmin from "@/pages/admin/TimetableAdmin";
import SuperAdminRoute from "@/components/SuperAdminRoute";
import ElevatedAdminRoute from "@/components/ElevatedAdminRoute";
import HomeRedirect from "@/components/HomeRedirect";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/dashboard" element={<ElevatedAdminRoute><Dashboard /></ElevatedAdminRoute>} />
            <Route path="/timetable" element={<Timetable />} />
            <Route path="/sessions" element={<Sessions />} />
            <Route path="/sessions/:id" element={<Session />} />
            <Route path="/classes" element={<ElevatedAdminRoute><Classes /></ElevatedAdminRoute>} />
            <Route path="/classes/:id" element={<ElevatedAdminRoute><ClassDetail /></ElevatedAdminRoute>} />
            <Route path="/sections" element={<ElevatedAdminRoute><Sections /></ElevatedAdminRoute>} />
            <Route path="/sections/:id" element={<ElevatedAdminRoute><SectionDetail /></ElevatedAdminRoute>} />
            <Route path="/students" element={<ElevatedAdminRoute><Students /></ElevatedAdminRoute>} />
            <Route path="/students/:id" element={<ElevatedAdminRoute><StudentDetail /></ElevatedAdminRoute>} />
            <Route
              path="/admin/timetable"
              element={
                <SuperAdminRoute>
                  <TimetableAdmin />
                </SuperAdminRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
